import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { catchError, map, Observable, of } from 'rxjs';

import { DataVariable } from '@mom/shared';

import { EnvironmentConfig } from '../config/environment.config';
import { PageContent } from '../models/content/page-content.model';
import { Country } from '../models/country.model';
import { HttpConstants } from '../models/http.constants';

@Injectable({ providedIn: 'root' })
export class SystemService {
  constructor(@Inject('environment') private environment: EnvironmentConfig, private http: HttpClient) {}

  getUsedTags(): Observable<string[]> {
    return this.http.get<string[]>(`${this.environment.endPoint}configs/tags`);
  }

  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(`${this.environment.endPoint}configs/countries`, {
      headers: { [HttpConstants.CacheIntercept]: 'COUNTRIES' }
    }).pipe(
      map((countries) => countries.sort((a, b) => a.countryName.localeCompare(b.countryName))),
      catchError(() => of([])
    ));
  }

  getContent(pageName: string): Observable<PageContent> {
    return this.http.get<PageContent>(`${this.environment.endPoint}configs/content/${pageName}`, {
      headers: { [HttpConstants.CacheIntercept]: pageName }
    });
  }

  getSystemDataVariables(): Observable<DataVariable[]> {
    return this.http.get<DataVariable[]>(`${this.environment.endPoint}configs/data-variable-type-cfg`, {
      headers: { [HttpConstants.CacheIntercept]: 'DATAVARIABLES' }
    });
  }
}
